import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../components/Layout/Loader";
import { server } from "../server";

const PostRedirectPage = () => {
  const navigate = useNavigate();
  const { postId } = useParams();

  useEffect(() => {
    let isActive = true;

    const redirectToPostTimeline = async () => {
      try {
        const response = await axios.get(`${server}/posts/get-post/${postId}`, {
          withCredentials: true,
        });

        const post = response.data?.post;
        const targetOwner = post?.originalPostOwner || post?.owner;
        const targetProfileType = post?.originalPostProfileType || post?.profileType || "User";
        const ownerId = targetOwner?._id;

        let handle = targetOwner?.handle || null;

        if (!handle && ownerId) {
          const handleResponse = targetProfileType === "Shop"
            ? await axios.get(`${server}/shop/get-shop-info/${ownerId}`, {
                withCredentials: true,
              })
            : await axios.get(`${server}/user/user-info/${ownerId}`, {
                withCredentials: true,
              });

          handle = targetProfileType === "Shop"
            ? handleResponse.data?.shop?.handle
            : handleResponse.data?.user?.handle;
        }

        if (!isActive) {
          return;
        }

        if (!handle) {
          navigate("/", { replace: true });
          return;
        }

        const basePath = targetProfileType === "Shop" ? `/shop/${handle}` : `/user/${handle}`;
        navigate(`${basePath}?postId=${encodeURIComponent(postId)}`, {
          replace: true,
        });
      } catch (error) {
        console.error("Failed to resolve post redirect:", error);

        if (isActive) {
          navigate("/", { replace: true });
        }
      }
    };

    redirectToPostTimeline();

    return () => {
      isActive = false;
    };
  }, [navigate, postId]);

  return <Loader />;
};

export default PostRedirectPage;